"use client";

import { useState } from "react";
import { Coins } from "lucide-react";
import { useTranslations } from "next-intl";

import { DonateModal } from "./donate-modal";

/**
 * Кнопка «Поддержать нас» для главной. Живёт в widgets, а не в shared/ui, потому что
 * тянет за собой модалку доната — shared импортировать widgets нельзя (ai/module-graph.md),
 * поэтому в HeroSection она приходит слотом.
 *
 * className прокидывается снаружи: на главной фон бывает светлым и тёмным, и кнопка
 * красится по тому же правилу, что и остальной текст героя (showLightText).
 */
export function DonateCtaButton({ className, style }: { className?: string; style?: React.CSSProperties }) {
  const t = useTranslations("Marketing.About.donate");
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={className} style={style}>
        <Coins className="h-4 w-4" />
        {t("button")}
      </button>
      <DonateModal open={open} onOpenChange={setOpen} />
    </>
  );
}
